export const InitInputValue = [
  {
    key: 0,
    text: 'Aguarde...',
    value: ''
  }
];

export const propertyTypesList: { key: string; text: string; value: string }[] = [
  {
    key: 'RESIDENCIAL',
    text: 'Residencial',
    value: 'RESIDENCIAL'
  },
  {
    key: 'EMPRESARIAL',
    text: 'Comercial',
    value: 'EMPRESARIAL'
  }
];
